import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '../../../core/services/api';
import { api } from '../../../models/api-url.model';
import type {
  ChangePasswordRequest,
  DeactivateOktaUserRequest,
  OktaUserRequest,
  OktaUserResponse,
} from './okta-user.types';

@Injectable({
  providedIn: 'root',
})
export class OktaUserService {
  private readonly apiService = inject(ApiService);

  createUser(payload: OktaUserRequest): Observable<OktaUserResponse> {
    return this.apiService.post(`${api.oktaUsersURL}`, payload);
  }

  updateUser(payload: OktaUserRequest): Observable<OktaUserResponse> {
    return this.apiService.put(`${api.oktaUsersURL}/${payload.login}`, payload);
  }

  deactivateUser(
    payload: DeactivateOktaUserRequest,
  ): Observable<OktaUserResponse> {
    return this.apiService.put(
      `${api.oktaUsersURL}/${payload.login}/deactivate`,
      payload,
    );
  }

  resendActivationEmail(login: string): Observable<OktaUserResponse> {
    return this.apiService.put(`${api.oktaUsersURL}/${login}/reactivate`);
  }

  onboardUser(payload: OktaUserRequest): Observable<OktaUserResponse> {
    return this.apiService.post(`${api.onboardOktaUsersURL}`, payload);
  }

  changePassword(payload: ChangePasswordRequest): Observable<OktaUserResponse> {
    return this.apiService.post(`${api.changeOktaPasswordURL}`, payload);
  }

  startOktaMigration(email: string): Observable<OktaUserResponse> {
    return this.apiService.post(`${api.oktaMigrationURL}`, { email });
  }
}
